export default "__VITE_ASSET__BXgmKXPj__"